(() => {
  const number = (value) => Number(value || 0);
  const escapeHtml = (value) => String(value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  const intervalFromPlan = (plan) => {
    if (String(plan?.deliveryInterval || '').toLowerCase() === 'month' && number(plan?.deliveryIntervalCount) > 0) {
      return number(plan.deliveryIntervalCount);
    }
    const source = `${plan?.name || ''}`.toLowerCase();
    const match = source.match(/(?:every|each)\s+(\d+)\s+months?/) || source.match(/(\d+)\s+months?/);
    if (match) return number(match[1]);
    return /every\s+month|monthly|1\s+month/.test(source) ? 1 : 0;
  };
  const monthText = (value) => {
    const rounded = Math.round(number(value) * 10) / 10;
    const label = Number.isInteger(rounded) ? rounded : rounded.toFixed(1);
    return `${label} ${rounded === 1 ? 'month' : 'months'}`;
  };

  const mount = (root) => {
    if (!root || root.dataset.cityReady === 'true') return;
    const form = root.closest('form');
    const info = root.closest('product-info');
    const dataNode = root.querySelector('[data-city-selling-plan-data]');
    if (!form || !dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (error) { return; }
    const cadence = window.CityContactLensCadence;
    if (!cadence) return;
    Object.values(data.variants || {}).forEach((variant) => {
      variant.plans = (variant.plans || []).map((plan) => ({ ...plan, interval: intervalFromPlan(plan) }));
    });

    const variantField = form.querySelector('input.product-variant-id[name=id]');
    const oneTimeRadio = root.querySelector('input[value=one-time]');
    const subscriptionRadio = root.querySelector('input[value=subscription]');
    const oneTimeCard = root.querySelector('[data-city-purchase-card=one-time]');
    const subscriptionCard = root.querySelector('[data-city-purchase-card=subscription]');
    const details = root.querySelector('.city-purchase-options__details');
    const frequency = root.querySelector('[data-city-delivery-frequency]');
    const sellingPlanField = root.querySelector('[data-city-selling-plan]');
    const firstPrice = root.querySelector('[data-city-first-price]');
    const futurePrice = root.querySelector('[data-city-future-price]');
    const oneTimePrice = root.querySelector('[data-city-one-time-price]');
    const badge = root.querySelector('[data-city-saving-badge]');
    const guidance = root.querySelector('[data-city-supply-guidance]');
    const announcement = root.querySelector('[data-city-cadence-announcement]');
    const submit = form.querySelector('button[name=add]');
    const submitLabel = submit?.querySelector('span');
    const currency = root.dataset.currency || window.Shopify?.currency?.active || 'AUD';
    const locale = root.dataset.locale || window.Shopify?.locale || 'en-AU';
    const money = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number(cents) / 100);
    let purchaseMode = 'one-time';
    let manuallySelected = false;
    let lastCadenceId = '';
    let cadenceState = null;
    let unavailableVariantId = '';

    const currentVariant = () => {
      const routed = window.CityContactLensSupply?.fromForm(form);
      if (routed?.variantId) return data.variants[String(routed.variantId)] || null;
      const direct = data.variants?.[String(variantField?.value || '')];
      if (direct) return direct;
      const checkedPack = info?.querySelector('input[type=radio][name="Size"]:checked, input[type=radio][name="Pack Size"]:checked');
      const byPack = Object.values(data.variants || {}).find((variant) => String(variant.title || '') === String(checkedPack?.value || ''));
      if (byPack) return byPack;
      const urlVariant = new URL(window.location.href).searchParams.get('variant');
      return data.variants?.[String(urlVariant || '')] || Object.values(data.variants || {})[0] || null;
    };
    const selectedLines = () => {
      const qty = quantities();
      const variantId = currentVariant()?.id;
      return [{ variantId, quantity: qty.left, side: 'Left Eye' }, { variantId, quantity: qty.right, side: 'Right Eye' }].filter((line) => line.quantity > 0);
    };
    const currentPlans = () => currentVariant()?.available === false ? [] : cadence.intersection(data.variants || {}, selectedLines());
    const selectedPlan = () => currentPlans().find((plan) => String(plan.id) === String(frequency.value || sellingPlanField.value || '')) || null;
    const phasePrices = (plan) => {
      const prices = plan?.allocationAdjustments?.map((phase) => phase.price == null ? null : number(phase.price)) || [];
      return { first: prices[0] ?? number(plan?.checkoutChargeAmount ?? plan?.price), future: prices[1] ?? number(plan?.price ?? prices[0]) };
    };
    const discountPercent = (plan) => {
      const base = number(plan?.compareAtPrice) || number(currentVariant()?.price);
      const future = phasePrices(plan).future;
      return base > 0 && future < base ? Math.round((base - future) * 100 / base) : 0;
    };
    const quantities = () => ({
      left: number(form.querySelector('select[name="properties[Quantity Left]"]')?.value),
      right: number(form.querySelector('select[name="properties[Quantity Right]"]')?.value)
    });
    const supplyState = () => window.CityContactLensSupply?.fromForm(form) || null;
    const totalBoxes = () => number(supplyState()?.totalBoxes) || quantities().left + quantities().right;

    const suppressNativeWidget = () => {
      form.dataset.cityPurchaseOptionsReady = 'true';
      form.querySelectorAll('.appstle_sub_widget, [id*="appstle_subscription_widget"]').forEach((widget) => {
        if (widget.getAttribute('aria-hidden') !== 'true') widget.setAttribute('aria-hidden', 'true');
      });
    };
    const ensureSummaryPosition = () => {
      const summary = form.querySelector('[data-city-clear-order-summary], [data-city-colour-order-summary], .city-colour-order-summary');
      if (!summary) return null;
      summary.dataset.cityPurchaseSummary = '';
      if (summary.previousElementSibling !== root) root.insertAdjacentElement('afterend', summary);
      return summary;
    };
    const updateGuidance = (plan) => {
      const supply = supplyState();
      if (!supply || !plan) { guidance.textContent = ''; return; }
      const left = number(supply.leftMonths);
      const right = number(supply.rightMonths);
      const activeMonths = [left, right].filter((months) => months > 0);
      const mismatch = cadenceState?.unequal;
      const reference = activeMonths[0] || 0;
      const scope = activeMonths.length === 1 ? 'for the selected eye' : 'per eye';
      const classifications = selectedLines().map((line) => cadence.classify(data.variants[String(line.variantId)]?.wearSchedule));
      const classification = classifications.length && classifications.every((value) => value === classifications[0]) ? classifications[0] : 'unknown';
      root.dataset.wearClassification = classification;
      const exact = cadenceState?.recommendation === plan.interval;
      guidance.classList.toggle('is-neutral', mismatch || !reference || !exact);
      if (!activeMonths.length) {
        guidance.textContent = 'Choose at least one box to compare supply with delivery frequency.';
      } else if (mismatch) {
        guidance.textContent = 'Left and right quantities provide different supply periods. Align quantities for matched deliveries.';
      } else if (exact) {
        const matchedMonths = Math.round(reference * 10) / 10;
        guidance.textContent = `Matches your ${Number.isInteger(matchedMonths) ? matchedMonths : matchedMonths.toFixed(1)}-month supply ${scope}${classification === 'daily' ? ' for daily wear' : ''}`;
      } else {
        const unavailable = cadenceState?.recommendation ? '' : 'No exact supply-matched cadence is available. ';
        const band = cadence.wearBand(reference, plan.interval);
        guidance.textContent = unavailable + (classification === 'daily'
          ? band === 'daily wear' ? 'Suitable for daily wear' : `Suitable if worn ${band}`
          : classification === 'reusable' ? 'Later delivery selected. Continue replacing opened lenses as directed.'
            : `Your order provides approximately ${monthText(reference)} ${scope}. Later delivery selected.`);
      }
    };
    const updateSummary = (plan) => {
      const summary = ensureSummaryPosition();
      if (!summary) return;
      const supply = supplyState();
      const boxes = totalBoxes();
      const lenses = number(supply?.totalLenses);
      const variant = currentVariant();
      const subscription = purchaseMode === 'subscription' && plan;
      const unit = subscription ? phasePrices(plan).first : number(variant?.price);
      const total = unit * boxes;
      const parameter = summary.querySelector('.city-contact-order-summary__parameters')?.outerHTML || '';
      if (boxes <= 0) {
        summary.innerHTML = `<span>Order summary</span><strong>Choose at least one box</strong><small>Select a quantity for the eye you are ordering for.</small>${parameter}`;
        return;
      }
      const boxLabel = `${boxes} ${boxes === 1 ? 'box' : 'boxes'}`;
      const leftMonths = number(supply?.leftMonths);
      const rightMonths = number(supply?.rightMonths);
      const supplyText = leftMonths > 0 && rightMonths > 0 && Math.abs(leftMonths - rightMonths) <= .05
        ? `Approx. ${monthText(leftMonths)} per eye`
        : leftMonths > 0 && rightMonths <= 0
          ? `Left eye ~${monthText(leftMonths)}`
          : rightMonths > 0 && leftMonths <= 0
            ? `Right eye ~${monthText(rightMonths)}`
            : `Left ~${monthText(leftMonths)} · Right ~${monthText(rightMonths)}`;
      if (subscription) {
        const phases = phasePrices(plan);
        const firstAdjustment = plan.planAdjustments?.[0];
        const initialOrders = number(firstAdjustment?.orderCount);
        const nextOrder = initialOrders + 1;
        const ordinal = nextOrder === 2 ? 'second' : nextOrder === 3 ? 'third' : `${nextOrder}th`;
        const futureLead = initialOrders > 0 ? `from ${ordinal} order` : 'per delivery';
        summary.innerHTML = `<span>Order summary</span><strong>${escapeHtml(boxLabel)} · ${lenses} lenses total · ${escapeHtml(money(total))} today</strong><small>Auto-delivery every ${plan.interval === 1 ? 'month' : `${plan.interval} months`}</small><small>${escapeHtml(money(phases.future * boxes))} ${futureLead} · ${escapeHtml(supplyText)}</small>${parameter}`;
      } else {
        summary.innerHTML = `<span>Order summary</span><strong>${escapeHtml(boxLabel)} · ${lenses} lenses total · ${escapeHtml(money(total))}</strong><small>${escapeHtml(supplyText)}</small>${parameter}`;
      }
    };
    const updateCta = () => {
      if (!submitLabel) return;
      if (info?.querySelector('[data-city-lens-intent]') && !form.dataset.cityLensIntent) return;
      const colourOwnsIncompleteCta = form.dataset.cityColourPrescriptionComplete != null
        || Boolean(info?.querySelector('[data-city-lens-intent]'));
      if (colourOwnsIncompleteCta && (form.dataset.cityColourPrescriptionComplete !== 'true' || totalBoxes() <= 0)) {
        if (form.dataset.cityContactCartPending === 'true' || submit?.classList.contains('loading')
          || currentVariant()?.available === false || variantField?.disabled
          || unavailableVariantId === String(variantField?.value)) submit.disabled = true;
        return;
      }
      const setText = (text, mode = 'complete') => {
        if (submitLabel.textContent.trim() !== text) submitLabel.textContent = text;
        form.dataset.cityClearStickyText = text;
        form.dataset.cityClearStickyMode = mode;
        const sticky = document.querySelector('[data-city-sticky-submit]');
        if (!sticky) return;
        if (sticky.textContent.trim() !== text) sticky.textContent = text;
        sticky.dataset.cityStickyRxMode = mode;
        sticky.classList.toggle('is-secondary', mode !== 'complete');
      };
      if (form.dataset.cityContactCartPending === 'true' || submit?.classList.contains('loading')) {
        submit.disabled = true;
        setText('Loading...', 'loading');
        return;
      }
      const clearComplete = submit?.dataset.cityClearPrescriptionComplete;
      const colourComplete = form.dataset.cityColourPrescriptionComplete;
      const complete = clearComplete != null ? clearComplete === 'true'
        : colourComplete != null ? colourComplete === 'true'
          : !/complete prescription/i.test(submitLabel.textContent || '');
      const variant = currentVariant();
      if (variant?.available === false || variantField?.disabled || unavailableVariantId === String(variantField?.value)) {
        submit.disabled = true;
        setText('Sold out', 'unavailable');
        return;
      }
      if (!complete) {
        setText('Complete prescription', 'incomplete');
        return;
      }
      if (totalBoxes() <= 0) {
        setText('Choose at least one box', 'quantity');
        return;
      }
      const plan = selectedPlan();
      const subscription = purchaseMode === 'subscription' && plan;
      const price = subscription ? phasePrices(plan).first : number(variant?.price);
      const text = subscription ? `Start auto-delivery — ${money(price * totalBoxes())}` : `Add to cart — ${money(price * totalBoxes())}`;
      setText(text);
    };
    const render = () => {
      // The live colour-lens flow intentionally asks for Plano / powered intent first.
      const awaitingIntent = Boolean(info?.querySelector('[data-city-lens-intent]')) && !form.dataset.cityLensIntent;
      if (awaitingIntent) {
        purchaseMode = 'one-time';
        root.hidden = true;
        sellingPlanField.disabled = true;
        sellingPlanField.value = '';
        root.dataset.selectedPlanId = '';
        suppressNativeWidget();
        return;
      }
      const previousId = lastCadenceId;
      cadenceState = cadence.choose({ plans: currentPlans(), supply: supplyState(), manualId: manuallySelected ? lastCadenceId : '' });
      const plans = cadenceState.options;
      const invalidated = manuallySelected && previousId && !cadenceState.manualValid;
      if (invalidated) manuallySelected = false;
      if (!plans.length) purchaseMode = 'one-time';
      root.hidden = false;
      suppressNativeWidget();
      const recommendation = cadenceState.recommendation;
      frequency.innerHTML = '';
      plans.sort((a, b) => a.interval - b.interval).forEach((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = `Every ${plan.interval === 1 ? 'month' : `${plan.interval} months`}${recommendation === plan.interval ? ' — Recommended' : ''}`;
        frequency.append(option);
      });
      frequency.value = String(cadenceState.selected?.id || '');
      lastCadenceId = frequency.value;
      subscriptionCard.hidden = plans.length === 0;
      subscriptionRadio.disabled = plans.length === 0;
      frequency.disabled = plans.length === 0;
      root.dataset.supplyFloor = String(cadenceState.floor);
      root.dataset.eligiblePlanIds = currentPlans().map((plan) => plan.id).join(',');
      root.dataset.submittedVariants = selectedLines().map((line) => line.variantId).join(',');
      if (invalidated && announcement) announcement.textContent = plans.length
        ? `Delivery frequency updated to every ${cadenceState.selected.interval === 1 ? 'month' : `${cadenceState.selected.interval} months`} to match the available supply intervals.`
        : 'No valid subscription delivery frequency is available for this selection. One-time purchase selected.';
      const plan = selectedPlan();
      const phases = phasePrices(plan);
      const boxes = totalBoxes();
      oneTimePrice.textContent = money(number(currentVariant()?.price) * boxes);
      firstPrice.textContent = `${money(phases.first * boxes)} today`;
      futurePrice.textContent = `then ${money(phases.future * boxes)}/delivery`;
      const saving = discountPercent(plan);
      badge.hidden = saving <= 0;
      badge.textContent = saving > 0 ? `SAVE ${saving}%` : '';
      const subscribed = purchaseMode === 'subscription';
      root.dataset.purchaseMode = purchaseMode;
      oneTimeRadio.checked = !subscribed;
      subscriptionRadio.checked = subscribed;
      oneTimeCard.classList.toggle('is-selected', !subscribed);
      subscriptionCard.classList.toggle('is-selected', subscribed);
      details.hidden = !subscribed;
      subscriptionRadio.setAttribute('aria-expanded', String(subscribed));
      sellingPlanField.disabled = !subscribed;
      sellingPlanField.value = subscribed ? String(plan?.id || '') : '';
      root.dataset.selectedPlanId = subscribed ? String(plan?.id || '') : '';
      updateGuidance(plan);
      updateSummary(plan);
      updateCta();
      const summaryText = ensureSummaryPosition()?.textContent || '';
      const ctaText = submit?.textContent || '';
      const checkedRadios = root.querySelectorAll('input[type=radio]:checked').length;
      const selectedCards = root.querySelectorAll('.city-purchase-options__card.is-selected').length;
      const summaryMatches = boxes <= 0
        ? /choose at least one box/i.test(summaryText)
        : subscribed ? /auto-delivery/i.test(summaryText) : !/auto-delivery/i.test(summaryText);
      const ctaMatches = (submit?.disabled && /loading|please wait/i.test(ctaText))
        || /complete prescription|choose at least one box|sold out/i.test(ctaText)
        || (subscribed ? /start auto-delivery/i.test(ctaText) : !/start auto-delivery/i.test(ctaText));
      const detailsMatch = details.hidden === !subscribed;
      const planMatches = subscribed
        ? Boolean(plan && root.dataset.selectedPlanId === String(plan.id) && !sellingPlanField.disabled && sellingPlanField.value === String(plan.id))
        : root.dataset.selectedPlanId === '' && sellingPlanField.disabled && sellingPlanField.value === '';
      const stateContract = checkedRadios === 1
        && selectedCards === 1
        && oneTimeRadio.checked === !subscribed
        && subscriptionRadio.checked === subscribed
        && detailsMatch
        && summaryMatches
        && ctaMatches
        && planMatches;
      root.dataset.stateContract = stateContract ? 'pass' : 'fail';
      root.dispatchEvent(new CustomEvent('city:purchase-options-state', {
        detail: { purchaseMode, checkedRadios, selectedCards, summaryMatches, ctaMatches, planMatches, stateContract }
      }));
      if (!stateContract) console.error('City purchase option state contract failed');
    };

    root.addEventListener('change', (event) => {
      if (event.target === oneTimeRadio || event.target === subscriptionRadio) purchaseMode = event.target.value;
      if (event.target === frequency) { manuallySelected = true; lastCadenceId = frequency.value; }
      render();
    });
    form.addEventListener('change', (event) => {
      if (!root.contains(event.target)) window.setTimeout(render, 0);
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[type=radio][name="Size"], input[type=radio][name="Pack Size"]')) render();
    });
    form.addEventListener('city:contact-lens-order-state', render);
    form.cityValidatePurchaseItems = (items) => {
      const plan = selectedPlan();
      const supply = supplyState();
      const actualPlans = cadence.intersection(data.variants, items.map(item => ({ variantId: item.id, quantity: item.quantity })));
      return items.length > 0 && items.every(item => String(item.id) === String(supply?.variantId))
        && items.reduce((sum, item) => sum + Number(item.quantity), 0) === supply?.totalBoxes
        && (purchaseMode === 'one-time' ? items.every(item => !item.selling_plan)
          : Boolean(plan && actualPlans.some(candidate => String(candidate.id) === String(plan.id))
            && cadence.choose({ plans: actualPlans, supply, manualId: String(plan.id) }).manualValid
            && items.every(item => String(item.selling_plan) === String(plan.id))));
    };
    form.addEventListener('city:contact-lens-cart-complete', render);
    document.addEventListener('city:contact-lens-supply-change', () => window.setTimeout(render, 0));
    document.addEventListener('variant-change', () => window.setTimeout(render, 0));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!root.isConnected) { unsubscribeVariant(); return; }
        const sectionId = form.closest('product-form')?.dataset.sectionId;
        if (String(event?.data?.sectionId) !== String(sectionId)
          || String(event?.data?.variant?.id) !== String(variantField?.value)) return;
        const refreshedButton = event.data.html?.getElementById(`ProductSubmitButton-${sectionId}`);
        if (submit && refreshedButton) {
          unavailableVariantId = refreshedButton.hasAttribute('disabled') || event.data.variant.available === false
            ? String(event.data.variant.id) : '';
          submit.disabled = form.dataset.cityContactCartPending === 'true'
            || submit.classList.contains('loading')
            || Boolean(unavailableVariantId);
        }
        render();
      });
    }
    new MutationObserver(() => { suppressNativeWidget(); ensureSummaryPosition(); updateCta(); }).observe(form, { childList: true, subtree: true });
    window.addEventListener('pageshow', () => window.setTimeout(render, 0));
    window.addEventListener('focus', () => window.setTimeout(render, 0));
    root.dataset.cityReady = 'true';
    render();
    [150, 600, 1500, 3500].forEach((delay) => window.setTimeout(render, delay));
  };

  const mountAll = (scope = document) => scope.querySelectorAll('[data-city-contact-purchase-options]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
})();
